import { IFtthOrchestrator } from "@nju/data-access-portal-orchestrator";
import { IconName } from "@nju/icons";

interface IStatusProps {
  iconName: IconName;
  title: string;
  text: string;
  showAdditionalInfo?: boolean;
}

export function getFtthStatusData(
  state: IFtthOrchestrator["state"],
  cancellationReason: IFtthOrchestrator["cancellationReason"],
): IStatusProps | undefined {
  if (state === "ORDER_COMMITTED") {
    return {
      title: "zamówienie złożone",
      text: "Przyjęliśmy Twoje zamówienie i je weryfikujemy. Będziemy informować Cię o statusie zamówienia.",
      iconName: "shopping-bag",
    };
  }

  if (state === "ORDER_FULFILLMENT" || state === "ORDER_PAYMENT") {
    return {
      title: "instalacja usługi",
      text: "Technik zainstaluje usługę nju światłowód w wybranym przez Ciebie terminie. Termin znajdziesz w  szczegółach zamówienia.",
      iconName: "user-hard-hat",
      showAdditionalInfo: true,
    };
  }

  if (state === "ORDER_HELD") {
    return {
      title: "zamówienie wstrzymane",
      text: "Zamówienie usługi nju światłowód zostało wstrzymane.",
      iconName: "pause-circle",
    };
  }

  if (state === "ORDER_FINISHING") {
    return {
      title: "oczekiwanie na konfigurację usługi",
      text: "Technik zainstalował usługę nju światłowód w Twoim lokalu. Trwa konfiguracja usługi w naszych systemach.",
      iconName: "cog",
      showAdditionalInfo: true,
    };
  }

  if (
    state === "ORDER_PENDING_CANCELLATION" &&
    cancellationReason === "NOSS_FAILED_BMK"
  ) {
    return {
      title: "zamówienie w trakcie anulowania",
      text: "Otrzymaliśmy informację o rezygnacji z zamówienia instalacji usługi nju światłowód. Usługa nie zostanie zainstalowana w Twoim lokalu.",
      iconName: "shopping-bag",
    };
  }

  if (
    state === "ORDER_PENDING_CANCELLATION" &&
    cancellationReason === "NOSS_FAILED_BMT"
  ) {
    return {
      title: "zamówienie w trakcie anulowania",
      text: "Otrzymaliśmy informację o braku możliwości technicznych instalacji usługi nju światłowód. Usługa nie zostanie zainstalowana w Twoim lokalu.",
      iconName: "shopping-bag",
    };
  }

  if (
    state === "ORDER_PENDING_CANCELLATION" &&
    cancellationReason === "agentRequest"
  ) {
    return {
      title: "zamówienie w trakcie anulowania",
      text: "Przyjęliśmy zlecenie na anulowanie zamówienia.",
      iconName: "shopping-bag",
    };
  }

  return undefined;
}
